import { useEffect, useState } from 'react';

import SvgIcon from '@/assets/svgIcon';
import toKoreanDate, { shortKoreanDateFormat } from '@/utils/toKoreanDate';

import _ErrorPage from './_ErrorPage';

const getTimeRange = (startMaintenance: string, endMaintenance: string) => {
  const start = startMaintenance.split('T');
  const end = endMaintenance.split('T');

  const startDate = toKoreanDate(start[0], shortKoreanDateFormat);
  const endDate = toKoreanDate(end[0], shortKoreanDateFormat);

  return `${startDate} ${start[1]} ~ ${endDate} ${end[1]}`;
};

interface Props {
  status: string; // 에러 상태 코드
  cause: string; // 에러 메시지
  startMaintenance: string; // 점검 시작 시간 ex) "2022-12-02T09:00"
  endMaintenance: string; // 점검 종료 시간 ex) "2022-12-02T18:00"
}

const MaintenancePage: React.FC = () => {
  const [info, _setInfo] = useState<Props>(
    JSON.parse(localStorage.getItem('maintenance') as string)
  );

  useEffect(
    () => () => {
      localStorage.removeItem('maintenance');
    },
    []
  );

  return (
    <_ErrorPage
      title={info ? '시스템 점검 중입니다' : '시스템 점검'}
      description={
        info
          ? `<div style='font-weight: 500; white-space: pre-line;'>
              <div style='color: #575B65; display: inline-grid;'>
                <p>작업 시간 동안 모든 서비스가 일시적으로 중단되오니 양해 부탁드립니다.</p>
                <p style='margin-top: 30px;'>보다 개선된 서비스 제공을 위해 최선을 다하겠습니다. <br/>감사합니다. </p>
              </div>
              <div style='background-color: #F9FAFC; padding: 24px 0px; margin-top: 32px; display: inline-grid; width: 100%; line-height: 150%;'>
                <p style='font-size: 20px; color: #383940;'>서비스 점검 일시</p>
                <p style='font-size: 16px; color: #4F64D7; margin-top: 8px;'>${getTimeRange(
                  info.startMaintenance,
                  info.endMaintenance
                )}</p>
              </div>
            </div>`
          : `<div style='margin: 20px 0px 60px'>아래의 홈으로 가기 버튼을 클릭하여 재시도 해주세요.</div>`
      }
      image={<SvgIcon name="InfoTriangle" className="mx-auto" />}
      buttonTo="/task"
      buttonLabel="홈으로"
    />
  );
};

export default MaintenancePage;
